module.exports = __webpack_public_path__ + "img/a6.7f04889d.jpg";